export default __webpack_public_path__ + "static/media/loading.d87e86bb.svg";